"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["module"], factory);
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.undefined = mod.exports;
  }
})(void 0, function (module) {
  "use strict";

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  var BCImageLoader = function () {
    function BCImageLoader(config) {
      _classCallCheck(this, BCImageLoader);
      config = config || {};
      this.transcoder = config.transcoder;
      if (!this.transcoder) {
        console.warn('transcoder not defined for image-loader, falling back to source');
      }
      this.scale = config.scale || 2;
      this.ignoreHeight = config.ignoreHeight || false;
    }
    _createClass(BCImageLoader, [{
      key: "_getImageHeight",
      value: function _getImageHeight(img) {
        return img.clientHeight;
      }
    }, {
      key: "_getImageWidth",
      value: function _getImageWidth(img) {
        return img.clientWidth;
      }
    }, {
      key: "loadImage",
      value: function loadImage(img) {
        var _this = this;
        // desired dimensions
        var width = this._getImageWidth(img) * this.scale;
        var height = this._getImageHeight(img) * this.scale;
        if (width === 0) {
          return;
        }
        if (!height || this.ignoreHeight) {
          // use 16:9 ratio
          height = width * (9 / 16);
        }
        var src = img.attributes['data-bc-src'] && img.attributes['data-bc-src'].value;

        //Check to see whether the image is larger than it was before
        var oldWidth = Number(img.getAttribute('data-bc-width'));
        var oldHeight = Number(img.getAttribute('data-bc-height'));
        if (!src || oldWidth >= width && oldHeight >= height) {
          //No source or image is smaller / the same size, don't load
          return;
        }
        img.setAttribute('data-bc-loading', true);
        var image = new Image();
        image.onload = function () {
          if (img.attributes['data-bc-background'] && img.attributes['data-bc-background'].value) {
            img.setAttribute('style', "background-image:url(".concat(image.src, ")"));
          } else {
            img.src = image.src;
          }
          img.setAttribute('data-bc-width', width);
          img.setAttribute('data-bc-height', height);
          img.setAttribute('data-bc-loading', false);
          if (_this.loaded) {
            _this.loaded();
          }
        };
        image.onerror = function (err) {
          return console.error(err);
        };
        image.src = this.transcoder ? "".concat(this.transcoder, "?image=").concat(src, "&width=").concat(width, "&height=").concat(height) : src;
        var alt = img.attributes['data-bc-alt'] && img.attributes['data-bc-alt'].value;
        if (alt) {
          img.setAttribute('alt', alt);
        }
      }
    }, {
      key: "loadAllImages",
      value: function loadAllImages() {
        var _this2 = this;
        var images = document.querySelectorAll('.bc-image-loader:not([data-bc-loading=true])');
        [].forEach.call(images, function (img) {
          return _this2.loadImage(img);
        });
      }
    }, {
      key: "loadImages",
      value: function loadImages() {
        var _this3 = this;
        this.timeout = setTimeout(function () {
          _this3.loadAllImages();
          _this3.interval = setInterval(function () {
            return _this3.loadAllImages();
          }, 1000);
        }, 0);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
      }
    }]);
    return BCImageLoader;
  }();
  module.exports = BCImageLoader;
});